import { useContext } from 'react';
import { Badge, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { HashLink } from 'react-router-hash-link';
import { Section } from '../../Types/Section';
import { LotDetailContext } from '../../Contexts/LotDetailContext';

export interface SectionNavigationProps {
    sections: Section[],
}

export function SectionNavigation({ sections }: SectionNavigationProps) {
    const { t } = useTranslation();
    const { lotDetail } = useContext(LotDetailContext);

    return (
        <Row className="gy-2 mb-2">
            {sections.map(section =>
                <Col xs={6} md={3} lg key={`${section.name}-section-link`}>
                    <HashLink to={`#${section.name}-${lotDetail.summary.lotNumber}-section`}>
                        <Badge bg="secondary" className="hashlink-text w-100 lighter">
                            {`${t<string>(section.title)}${section.titleSuffix ? ` (${section.titleSuffix})` : ''}`}
                        </Badge>
                    </HashLink>
                </Col>
            )}
        </Row>
    );
}
